import { ParsedCode } from "../../state/selectors";
import ScrollPageIndexUpdater from "../../functionalComponents/ScrollPageIndexUpdater";
import ScrollPageWrapper from "./ScrollPageWrapper";
import styled from "styled-components";
import { useRecoilValue } from "recoil";
import { useRef } from "react";

const StyledScrollContainer = styled.div`
	height: 100%;
	overflow-y: auto;
	width: 100%;
	position: relative;
`;

function ScrollElements(): JSX.Element {
	const parsedCode = useRecoilValue(ParsedCode);
	const totalPages = parsedCode.length;
	const scrollerRef = useRef<HTMLDivElement>(null);

	return (
		<StyledScrollContainer id="scroll-elements-container" ref={scrollerRef}>
			<ScrollPageIndexUpdater />
			{Array.from({ length: totalPages }, (_, i) => i + 1).map((pageIndex) => (
				<ScrollPageWrapper
					pageIndex={pageIndex}
					key={`scroll-page-wrapper-${pageIndex}`}
					scrollerRef={scrollerRef}
				/>
			))}
		</StyledScrollContainer>
	);
}

export default ScrollElements;
